import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import Checkbox from '../../../ui/Checkbox';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { setInstitutionToDeactivate } from '../../../store/adminSlices/institutions';
import { setEditorToDeactivate } from '../../../store/adminSlices/editors';
const DeactivateAdminUnit = ({ unitId, unit }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [deactivateRallies, setDeactivateRallies] = useState(false);
    const handleDeactivationConfirm = async () => {
        try {
            if (unit === 'institution') {
                dispatch(setInstitutionToDeactivate({ id: unitId, deactivateRallies }));
            }
            if (unit === 'editor') {
                dispatch(setEditorToDeactivate({ id: unitId, deactivateRallies }));
            }
        }
        catch (_) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return (_jsxs("div", { className: 'modal-content deactivate-admin-unit', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t(unit === 'institution' ? 'admin.deactivate_institution' : 'admin.deactivate_editor'), type: 'h1' }) }), _jsx("div", { className: "modal-content-checkbox", children: _jsx(Checkbox, { id: 'deactivate-rallies-confirmation', label: t('label.deactivate_related_rallies'), checked: deactivateRallies, onChange: () => setDeactivateRallies((prev) => !prev), labelColor: '#000' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.cancel'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            }, tabIndex: 1 }), _jsx(Button, { variant: 'outlined', label: t('button.deactivate'), onClick: handleDeactivationConfirm, tabIndex: 1 })] }) })] }));
};
export default DeactivateAdminUnit;
